<zdb-card>
  <div class="card-header">
    <h1 class="card-title">{{ title }}</h1>
    <p class="card-text">
      {{ description }}
    </p>
  </div>
</zdb-card>
